import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import FormInput from '../../common/form/Input';
import LoadingOverlay from '../../common/LoadingOverlay';
import * as identity from '../../../utilities/identity';
import '../../../styles/AdminPage.css';
import { browserHistory } from '../../../utilities/history';
import FormPhoneInput from '../../common/form/PhoneInput';
import Form from '../../common/form/Form';
import { formatPhoneNumber } from '../../../utilities/Utils';
import {
    getMyUser,
    updateSelfUsername,
    updateSelfEmail,
    updateSelfPassword,
    updateSelfInfo
} from '../../../api/User';
//import FormSelectLabeled from '../../common/form/SelectLabeled';

interface State {
    email: string;
    username: string;
    newPassword: string;
    currentPassword: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    roleId: string;
    permissionId: string[];
    contextAvailableRoles: { id: string; name: string }[];
    contextAvailablePermissions: { id: string; name: string }[];
    wasEmailFormValidated: boolean;
    wasPasswordFormValidated: boolean;
    wasPersonalInfoFormValidated: boolean;
    isLoading: boolean;
    errorMessage: string | null;
    successMessage: string | null;
}

interface Props extends RouteComponentProps<{}> { }

class AccountSubPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            email: '',
            username: '',
            newPassword: '',
            currentPassword: '',
            firstName: '',
            lastName: '',
            phoneNumber: '',
            roleId: '',
            permissionId: [],
            contextAvailableRoles: [],
            contextAvailablePermissions: [],
            wasEmailFormValidated: false,
            wasPasswordFormValidated: false,
            wasPersonalInfoFormValidated: false,
            isLoading: true,
            errorMessage: null,
            successMessage: null
        };

        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.onEmailSubmit = this.onEmailSubmit.bind(this);
        this.onPasswordSubmit = this.onPasswordSubmit.bind(this);
        this.onPersonalInfoSubmit = this.onPersonalInfoSubmit.bind(this);
        this.onUsernameSubmit = this.onUsernameSubmit.bind(this);
    }

    async componentDidMount() {
        let userResult = await getMyUser();
        const role = identity.getMyRole();
        const permissions = identity.getMyPermissions();
        console.log("Permissions List: ", permissions);

        if (userResult.success) {
            this.setState({
                isLoading: false,
                firstName: userResult.data!.firstName,
                lastName: userResult.data!.lastName,
                phoneNumber: formatPhoneNumber(userResult.data!.phone),
                email: userResult.data!.email,
                username: userResult.data!.username,
                roleId: Array.isArray(role) ? role[0] : role || '',
                permissionId: Array.isArray(permissions) ? permissions : [],
                contextAvailableRoles: Array.isArray(role)
                    ? role.map((r) => ({ id: r, name: r }))
                    : role
                    ? [{ id: role, name: role }]
                    : [],
                contextAvailablePermissions: Array.isArray(permissions)
                    ? permissions.map((perm) => ({ id: perm, name: perm }))
                    : permissions
                    ? [{ id: permissions, name: permissions }]
                    : []        
            });
        } else {
            this.setState({
                ...this.state,
                isLoading: false,
                errorMessage: userResult.error!
            });
        }
    }

    render() {
        return (
            <div className='container'>
                <div className="position-relative">
                    <LoadingOverlay show={this.state.isLoading} inBootstrapColumn={false} />
                    {this.state.errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    )}
                    {this.state.successMessage && (
                        <div className="alert alert-success" role="alert">
                            {this.state.successMessage}
                        </div>
                    )}
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <h5>Update Username</h5>
                            <p>When you update your username, you will be signed out</p>
                        </div>
                        <Form
                            wasFormValidated={this.state.wasEmailFormValidated}
                            inBootstrapColumn={true}
                            submitButtonText="Update Username"
                            onSubmit={this.onUsernameSubmit}
                            onFormValidated={() =>
                                this.inputChangeHandler('wasEmailFormValidated', true)
                            }
                            divClassname="col-lg-8 col-12"
                        >
                            <FormInput
                                inputProps={{
                                    id: 'username',
                                    name: 'username',
                                    required: true,
                                    value: this.state.username,
                                    type: 'username'
                                }}
                                labelProps={{
                                    labelText: 'Username',
                                    invalidText: 'Please enter a valid username'
                                }}
                                onChange={this.inputChangeHandler}
                            />
                        </Form>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <h5>Update Email</h5>
                        </div>
                        <Form
                            wasFormValidated={this.state.wasEmailFormValidated}
                            inBootstrapColumn={true}
                            submitButtonText="Update Email"
                            onSubmit={this.onEmailSubmit}
                            onFormValidated={() =>
                                this.inputChangeHandler('wasEmailFormValidated', true)
                            }
                            divClassname="col-lg-8 col-12"
                        >
                            <FormInput
                                inputProps={{
                                    id: 'email',
                                    name: 'email',
                                    required: true,
                                    value: this.state.email,
                                    type: 'email'
                                }}
                                labelProps={{
                                    labelText: 'Email Address',
                                    invalidText: 'Please enter a valid email address'
                                }}
                                onChange={this.inputChangeHandler}
                            />
                        </Form>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <h5>Update Password</h5>
                        </div>
                        <Form
                            wasFormValidated={this.state.wasPasswordFormValidated}
                            inBootstrapColumn={true}
                            submitButtonText="Update Password"
                            onSubmit={this.onPasswordSubmit}
                            onFormValidated={() =>
                                this.inputChangeHandler('wasPasswordFormValidated', true)
                            }
                            divClassname="col-lg-8 col-12"
                        >
                            <div className="row">
                                <div className="col-6">
                                    <FormInput
                                        inputProps={{
                                            id: 'current-password',
                                            name: 'currentPassword',
                                            type: 'password',
                                            value: this.state.currentPassword,
                                            required: true
                                        }}
                                        labelProps={{
                                            labelText: 'Current Password',
                                            invalidText: 'Please enter your current password'
                                        }}
                                        onChange={this.inputChangeHandler}
                                    />
                                </div>
                                <div className="col-6">
                                    <FormInput
                                        inputProps={{
                                            id: 'new-password',
                                            name: 'newPassword',
                                            type: 'password',
                                            value: this.state.newPassword,
                                            required: true,
                                            minLength: 12
                                        }}
                                        labelProps={{
                                            labelText: 'New Password',
                                            invalidText:
                                                'Please enter a password using at least 12 characters'
                                        }}
                                        onChange={this.inputChangeHandler}
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <h5>Update Personal Info</h5>
                        </div>
                        <Form
                            wasFormValidated={this.state.wasEmailFormValidated}
                            inBootstrapColumn={true}
                            submitButtonText={'Update Personal Info'}
                            onSubmit={this.onPersonalInfoSubmit}
                            onFormValidated={() =>
                                this.inputChangeHandler('wasEmailFormValidated', true)
                            }
                            divClassname={'col-lg-8 col-12'}
                        >
                            <div className="row">
                                <div className="col-6">
                                    <FormInput
                                        inputProps={{
                                            id: 'first-name',
                                            name: 'firstName',
                                            value: this.state.firstName,
                                            required: true
                                        }}
                                        labelProps={{
                                            labelText: 'First Name',
                                            invalidText: 'Please enter a valid first name'
                                        }}
                                        onChange={this.inputChangeHandler}
                                    />
                                </div>
                                <div className="col-6">
                                    <FormInput
                                        inputProps={{
                                            id: 'last-name',
                                            name: 'lastName',
                                            value: this.state.lastName,
                                            required: true
                                        }}
                                        labelProps={{
                                            labelText: 'Last Name',
                                            invalidText: 'Please enter a valid last name'
                                        }}
                                        onChange={this.inputChangeHandler}
                                    />
                                </div>
                            </div>
                            <FormPhoneInput
                                inputProps={{
                                    id: 'phone-number',
                                    name: 'phoneNumber',
                                    value: this.state.phoneNumber,
                                    required: true
                                }}
                                labelProps={{
                                    labelText: 'Phone Number'
                                }}
                                onChange={this.inputChangeHandler}
                            />
                        </Form>
                    </div>
                    <hr />
                    <div className="row">
            <div className="col-lg-4 col-12">
                <h5>Access</h5>
            </div>
            <div className="col-lg-8 col-12">
                <div className="mb-3">
                    <label
                        htmlFor="role-id"
                        className="form-label"
                        style={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            fontSize: '10px',
                        }}
                    >
                        Role
                    </label>
                    <input
                        id="role-id"
                        className="form-control"
                        value={this.state.roleId}
                        disabled
                        readOnly
                    />
                </div>

                <div>
                <label
                        className="form-label"
                        style={{
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            fontSize: '10px',
                        }}
                    >
                        Permissions
                    </label>
                    <div className="mb-3">
                        <textarea
                            className="form-control"
                            rows={Math.max(this.state.contextAvailablePermissions.length, 2)}
                            value={
                                this.state.contextAvailablePermissions.length > 0
                                    ? this.state.contextAvailablePermissions.map((perm) => perm.name).join('\n')
                                    : 'No Permissions Assigned'
                            }
                            disabled
                            readOnly
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
)
        

}

    private async onUsernameSubmit() {
        let submitResult = await updateSelfUsername({
            newUsername: this.state.username
        });
        if (submitResult.success) {
            this.setState({
                ...this.state,
                successMessage: 'Username updated successfully'
            });
            identity.clearToken();
            browserHistory.push('/login');
        } else {
            this.setState({
                ...this.state,
                errorMessage: submitResult.error!
            });
        }
    }

    private async onEmailSubmit() {
        let updateResult = await updateSelfEmail({
            newEmail: this.state.email
        });

        if (updateResult.success) {
            this.setState({
                ...this.state,
                successMessage: 'Email updated successfully'
            });
        } else {
            this.setState({
                ...this.state,
                errorMessage: updateResult.error!
            });
        }
    }

    private async onPasswordSubmit() {
        let updateResult = await updateSelfPassword({
            newPassword: this.state.newPassword,
            currentPassword: this.state.currentPassword
        });

        if (updateResult.success) {
            this.setState({
                ...this.state,
                successMessage: 'Password updated successfully'
            });
        } else {
            this.setState({
                ...this.state,
                errorMessage: updateResult.error!
            });
        }
    }

    private async onPersonalInfoSubmit() {
        let updateResult = await updateSelfInfo({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phoneNumber
        });

        if (updateResult.success) {
            this.setState({
                ...this.state,
                successMessage: 'Info updated successfully'
            });
        } else {
            this.setState({
                ...this.state,
                errorMessage: updateResult.error!
            });
        }
    }

    private inputChangeHandler(inputName: string, newValue: string | boolean | number) {
        this.setState({
            ...this.state,
            [inputName]: newValue,
            errorMessage: null,
            successMessage: null
        });
    }
}

export default withRouter<Props>(AccountSubPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/AccountSubPage.tsx